/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// utils
import { getElementCSSProperty } from '@insticator/insticator-ui'; // iui-utils
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/editabletext/editabletext_styles';



/* ========== ~~~~~~~~~~ EDITABLE TEXT ~~~~~~~~~~ ========== */
class EditableText extends Component {
    constructor(props) {
        super(props);
        this.editableEl = null;
        this.state = {
            characterCount: this.getInitialCharacterCount(props),
        }
    }

    getInitialCharacterCount = (props) => !props.isOption && typeof props.textValue === 'string' ? props.textValue.length : 0;

    componentDidUpdate(prevProps) {
        if (!this.props.isOption &&  (prevProps.textValue !== this.props.textValue)) {
            this.setCharacterCount(this.props.textValue);
            this.props.validateText(this.props.textValue);
        }
    }

    componentWillUnmount() {
        if (this.props.isEditable) {
            this.editableEl.blur();
            this.pushTextToStore(this.editableEl.innerText);
        }
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.contentId === nextProps.contentId) {
            if (this.props.optionText !== nextProps.optionText || this.props.textValue !== nextProps.contentTitle) {
                return true
            } else if (this.props.isSelected && this.props.isEditable && this.props.textValue !== nextProps.contentTitle && nextProps.contentTitle !== null) {
                return false;
            } else if (this.props.isEditable && this.props.optionText !== nextProps.optionText) {
                return false;
            } else {
                return true;
            }
        }
        return true;
    };

    handleKeyDown = e => {
        if (this.props.onKeyDown !== undefined) { this.props.onKeyDown(e.target.textContent, getElementCSSProperty(e.target, 'height')); }
        if (this.props.preventEnter && e.which === 13) { e.preventDefault(); return false; }
        // check if we've hit character limit (passed in as prop)
        if (this.props.characterLimit !== undefined && (e.target.textContent.length >= this.props.characterLimit) && (e.key.length === 1)) {
           e.preventDefault();
        }
    };

    handleKeyUp = (e) => {
        if (this.props.onKeyUp !== undefined) { this.props.onKeyUp(e.target.textContent, getElementCSSProperty(e.target, 'height')); }
        this.setCharacterCount(e.target.textContent);
        // needed to dynamically resize text via classes and callback functions
        if (this.props.onTextEdit !== undefined) {
            this.props.onTextEdit(e.target.textContent, e);
        }
    };

    handleFocus = e => {
        if (this.props.onFocus !== undefined) { this.props.onFocus(e.target.textContent, getElementCSSProperty(e.target, 'height')); }
    };

    handleBlur = e => {
        if (this.props.onBlur === undefined) return null;
        // Trigger children's onBlur method
        this.props.onBlur(e.target.textContent, getElementCSSProperty(e.target, 'height'));
        // Update text in the application state
        const trimmedText = e.target.textContent !==null && e.target.textContent.trim().length > 0 ? e.target.textContent.trim(): null;
        this.pushTextToStore(trimmedText)
    };

    pushTextToStore = text => this.props.isOption ? this.updateOptionText(text) : this.updateQuestionTitle(text);

    updateOptionText = text => {
        if(this.props.optionText !== text) this.props.updateOptionProperty(this.props.contentId, this.props.optionId, 'text', text);
    };

    updateQuestionTitle = text => {
        if (this.props.textValue === text) return null;
        return this.props.isStory ? this.props.setStoryProperty(this.props.contentId, this.storyTextType(), text) :
            this.props.setQBProperty(this.props.contentId, 'title', text);
    };

    storyTextType = () => this.props.textType === 'storyTitle' ? 'title' : 'ctaText';

    handlePaste = (e) => {
        e.preventDefault();
        let text = e.clipboardData.getData("text/plain");
        // This will prevent users from pasting more than allowed characters in the div
        if (this.props.characterLimit !== undefined && typeof this.props.characterLimit === 'number') {
            text = e.clipboardData.getData("text/plain").slice(0, (this.props.characterLimit - e.target.textContent.length));
        }
        let temp = document.createElement("div");
        temp.innerHTML = text;
        document.execCommand("insertHTML", false, temp.textContent);
    };

    setCharacterCount = (text) => {
        const characterCount = typeof text === 'string' ? text.length : 0;
        if(this.props.isEditable && !this.props.isOption && this.state.characterCount !== characterCount) this.setState({ characterCount });
    };

    getLimitClass = () => {
        if (!this.props.isEditable || this.props.isOption) return 'none';
        if (typeof this.props.characterLimit !== 'number' || typeof this.state.characterCount !== 'number' ||  this.props.characterLimit === 0) return 'none';
        const fillRate = this.state.characterCount / this.props.characterLimit;
        return this.props.characterLimit === this.state.characterCount ? 'reached' : fillRate >= 0.85 ? 'approaching' : 'none';
    };

    _renderCharacterCount = () => this.props.isEditable && !this.props.isOption ? <div className={`charactercount limit-${this.getLimitClass()}`}>{`${this.state.characterCount}/${this.props.characterLimit}`}</div> : null;

    render() {
        return (
            <div className={` ${this.props.classes.editabletextwrapper} editabletextwrapper`}>
                {this._renderCharacterCount()}
                <div ref={(e) => { if (e != null) { this.editableEl = e ; e.contentEditable = 'true';} }}
                     style={this.props.style}
                     className={`editabletext`}
                     data-text={this.props.placeholder !== undefined ? this.props.placeholder : this.props.isOption ? 'Type answer' : 'Type your question here'}
                     onKeyUp={this.handleKeyUp}
                     onKeyDown={this.handleKeyDown}
                     onFocus={this.handleFocus}
                     onBlur={this.handleBlur}
                     onPaste={this.handlePaste}
                >
                    {this.props.isOption ? this.props.optionText : this.props.textValue}
                </div>
            </div>

        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(EditableText);
